<script>
import { Line } from 'vue-chartjs';

export default {
  name: 'MediaTurmas',
  extends: Line ,
  props: {
    dados: {
      type: Object,
      default() {
        return {
          labels: [],
          data: [],
        };
      },
    },
  },
  watch: {
    dados() {
      this.renderChart({
        labels: this.dados.labels,
        datasets: [
          {
            backgroundColor: '#01579B',
            borderColor: '#01579B',
            data: this.dados.data,
            pointRadius: 5,
            pointHoverRadius: 15,
            fill: false
          }
        ]
      }, {
        maintainAspectRatio: false,
        spanGaps: false,
        responsive: true,   
        elements: {
		  		line: {
		  			tension: 0.000001
		  		}
        },
        plugins: {
		  		filler: {
		  			propagate: false
		  		}
		  	},
        scales: {
		  		xAxes: [{
		  			ticks: {
		  				autoSkip: false,
              maxRotation: 0,
              fontSize: 8,
		  			}
		  		}]
        },
        legend: {
           display: false
        },
      });
    },
  },
  mounted() {
    
  },
}
</script>

<style>

</style>
